import { z } from 'zod';
import { signalSeveritySchema } from './enums';

export const windowedSignalValueDTOSchema = z.object({
  kind: z.literal('windowed'),
  verdict: z.enum(['stable', 'drop', 'surge']),
  severity: signalSeveritySchema.nullable(),
  recent: z.number(),
  baseline: z.number(),
  sampleSize: z.number(),
  // Per-window sample counts; optional because rows written before this field lack them.
  recentCount: z.number().optional(),
  baselineCount: z.number().optional(),
  deltaPercent: z.number().nullable(),
  perDayRecent: z.array(z.number()).optional(),
  perDayBaseline: z.array(z.number()).optional(),
  recentStart: z.string(),
  recentEnd: z.string(),
  baselineStart: z.string(),
  baselineEnd: z.string(),
  dimensionLabel: z.string().optional(),
  scopeKey: z.string().optional(),
  loopIds: z.array(z.number()).optional(),
  loopProvenance: z.string().optional(),
});

export const eventSignalValueDTOSchema = z.object({
  kind: z.literal('event'),
  verdict: z.enum(['not_triggered', 'triggered']),
  severity: signalSeveritySchema.nullable(),
  count: z.number(),
  periodStart: z.string(),
  periodEnd: z.string(),
  subjectKeys: z.array(z.string()).optional(),
  affectedItemIds: z.array(z.number()).optional(),
  relevantItemIds: z.array(z.number()).optional(),
  affectedPrKeys: z.array(z.string()).optional(),
  blockerOwnerTeams: z.array(z.string()).optional(),
  total: z.number().optional(),
  topShare: z.number().optional(),
  distinctAssignees: z.number().optional(),
  scopeKey: z.string().optional(),
  loopIds: z.array(z.number()).optional(),
  loopProvenance: z.string().optional(),
});

export const signalValueDTOSchema = z.discriminatedUnion('kind', [
  windowedSignalValueDTOSchema,
  eventSignalValueDTOSchema,
]);
export type SignalValueDTO = z.infer<typeof signalValueDTOSchema>;
